import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification } from "antd";
import { faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import TobNavBar from "../../../DashBaord/Top_navbar";
import { useNavigate, useParams } from "react-router-dom";
import { InfoCircleOutlined, CheckCircleOutlined, } from "@ant-design/icons";
import moment from "moment";
import SkeltonList from "../../../../components/SkeltonEffect/list";
import {
  list,
  deleteRequest,
  getLoadBalanceData,
  updateInvoice,
  requestChangeStatus
} from "../../../../controllers/V1/k_winnInvoice/invoiceControllers";
import { getRelativeTime } from "../../../../controllers/common";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};


export default function BasicTabs() {
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const targetRef = useRef(null);
  const {batch_id}= useParams();
  const [ALLLISTDATA, setListData] = useState([]);

  const [pendingInvoice, setPendingInvoice] = useState([]);
  const [pendingInvoiceCount, setPendingInvoiceCount] = useState(0);
 
  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          batch_no : batch_id
        },
        select: {},
        sort: { _id: -1 },
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          let updatedRetailerList = listData?.result.filter((retailer) => retailer?.status === 'Pending');
          // let updatedRetailerList = listData?.result.filter((retailer) => retailer?.status === 'Completed');
          setPendingInvoice(updatedRetailerList);
          setPendingInvoiceCount(updatedRetailerList?.length); 

        } else {
          setListData([]);
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End
 

  /*********************************************************
   *  This function is use to handle remove invoice
   *********************************************************/
  const handleRemove = async (id='') => {
    try {
      if(!id){
        notification.open({
          message: "Oops!",
          description: `Invoice id is required.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }else{
        const res = await deleteRequest(id);
        if (res.status === true) {
          notification.open({
            message: "Success",
            description: `Data deleted successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Operation not perform yet! please try in some time.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
    getList();
  };
  
  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "K-Winn CRm || Invoice Generate";
  }, []);
  
  const fetchUserDue = async (user_id) => {
    return 0;
    try {
      const option = {
        type : 'single',
        condition : { users_oid : user_id },
        select : {due_amount : true}
      }
      // const res = await dueList(option);
      // if(res.status === true){
      //   return res.result?.due_amount
      //   // setInvoiceData((pre)=>({
      //   //   ...pre,
      //   //   old_balance : due?.due_amount
      //   // }))
      // } else{
      //   return 0;
      //   // setInvoiceData((pre)=>({
      //   //   ...pre,
      //   //   old_balance : 0
      //   // }))
      // }
    } catch (error) {
      return 0;
    }
  }

  useEffect(()=>{
    if(pendingInvoiceCount > 0){
      generateInvoice(pendingInvoice[pendingInvoiceCount - 1]);
    } else {
      requestChangeStatus(batch_id);
    }
  },[pendingInvoiceCount]);


/*********************************************************
 *  This function is use to handle form submit
 *********************************************************/
const generateInvoice = async (data) => {
  try {
    if(!data.users_id){
      alert('Please select user');
    } else{
      setListData((prev) =>
        prev.map((item) =>
          item._id === data._id ? { ...item, status: 'Preparing' } : item
        )
      );

      const startDate = moment(data?.start_date).format('YYYY-MM-DD');
      const endDate = moment(data?.end_date).format('YYYY-MM-DD');

      const startTime = data?.start_time || '21:31:00';
      const endTime = data?.end_time || '21:30:00';

      const options = {
        condition : {
          $or : [
            {debit_user : data?.users_oid},
            {credit_user :data?.users_oid}
          ],
          created_at : { $gte : `${startDate} ${startTime}`, $lte : `${endDate} ${endTime}` }
        }
      }
      const res = await getLoadBalanceData(options);
      if(res?.status === true){

         //Lotto
         let lottoTotalSalesAmount = 0;
         let lottoTotalCommissionAmount = 0;
         let lottoTotalPaidAmount = 0;

         //Recharge
         let rechargeTotalSalesAmount = 0;
         let rechargeTotalCommissionAmount = 0;
         let rechargeTotalPaidAmount = 0;
         
         //Raffle
         let raffleSales = 0;
         let raffleCommission = 0;
         let raffleAmountPaid = 0
         
         let salesAmount = 0;
         let commissionAmount = 0;
         let paidAmount = 0;
         let insensitiveAmount = 0;
         
         let old_balance
         let totalDueAmount = 0;
         let subTotalDue = 0;
         let total_debit = 0;

        let status = 'Completed';
        let remarks = '';
        if(res?.result?.length > 0){

          const result = res?.result?.reduce(
            (acc, item) => {
              //Lotto
                if (item.narration === "Campaign Purchase") {
                    acc.orderSum += item.points || 0;
                } else if (item.narration === "Campaign Purchase Cancel") {
                    acc.cancelledSum += item.points || 0;
                } else if(item.narration === 'Campaign Commission'){
                    acc.commissionSum += parseFloat(item.points) || 0;
                } else if(item.narration === 'Campaign Commission Cancel'){
                    acc.commissionRevertedSum += parseFloat(item.points) || 0;
                } else if(item.narration === 'Lotto Winner Redeem'){
                  acc.paidSum += parseFloat(item.points) || 0;
                }
                // //Recharge
                // else if(item.narration === "Mobile Recharge" || item.narration === "Mobile Recharge Success"){
                //   acc.rechargeOrdSum += item.points || 0;
                // } else if(item.narration === "Mobile Recharge Failed"){
                //   acc.rechargeCancelSum += item.points || 0;
                // } else if(item.narration === "Mobile Recharge Commission"){
                //   acc.rechargeCommissionSum += item.points || 0;
                // } else if(item.narration === "Mobile Recharge Commission Reverse"){
                //   acc.rechargeCommissionReverse += item.points || 0;
                // }

                //Recharge
                else if(
                  item.narration === "Mobile Recharge" || 
                  item.narration === "Mobile Recharge Success" || 
                  item.narration === "Gift Voucher Purchase" 
                ){
                  acc.rechargeOrdSum += item.points || 0;
                } else if(
                  item.narration === "Mobile Recharge Failed" || 
                  item.narration === "Refund Gift Voucher" || 
                  item.narration === "Refund Inactive Gift Voucher"
                ){
                  acc.rechargeCancelSum += item.points || 0;
                } else if(
                  item.narration === "Mobile Recharge Commission" || 
                  item.narration === "Gift Voucher Commission"
                ){
                  acc.rechargeCommissionSum += item.points || 0;
                } else if(
                  item.narration === "Inactive Gift Voucher Deduct Commission"
                ){
                  acc.rechargeCommissionSum -= item.points || 0;
                } else if(
                  item.narration === "Mobile Recharge Commission Reverse" || 
                  item.narration === "Gift Voucher Deduct Commission"
                ){
                  acc.rechargeCommissionReverse += item.points || 0;
                }

                //Raffle
                else if(item.narration === "Raffle Campaign Purchase"){
                  acc.raffleSales += item.points || 0;
                } else if(item.narration === "Raffle Campaign Commission"){
                  acc.raffleCommission += item.points || 0;
                } else if(item.narration === "Raffle Campaign Purchase Cancel"){
                  acc.raffleSales -= item.points || 0;
                } else if(item.narration === "Raffle Campaign Commission Reverse"){
                  acc.raffleCommission -= item.points || 0;
                } else if(item.narration === "Raffle Winner Redeem"){
                  acc.raffleAmountPaid += item.points || 0;
                }

                return acc;
            },
            { 
              orderSum: 0, cancelledSum: 0, commissionSum : 0, commissionRevertedSum:0, paidSum : 0,
              rechargeOrdSum : 0, rechargeCancelSum : 0, rechargeCommissionSum : 0, rechargeCommissionReverse : 0, rechargePaidSum : 0,
              raffleSales : 0, raffleCommission : 0, raffleAmountPaid : 0, raffleIncentive : 0 
            }
          );

          console.log('result', result); 
          // const totalSales = parseFloat(result.orderSum) - parseFloat(result.cancelledSum);
          const totalCommission = parseFloat(result.commissionSum) - parseFloat(result.commissionRevertedSum);
          //Lotto
          lottoTotalSalesAmount = parseFloat(result.orderSum) - parseFloat(result.cancelledSum);
          lottoTotalCommissionAmount = totalCommission;
          lottoTotalPaidAmount = result?.paidSum;
          //Raffle
          const totalRechargeSales = parseFloat(result.rechargeOrdSum) - parseFloat(result.rechargeCancelSum);
          const totalRechargeCommission = parseFloat(result.rechargeCommissionSum) - parseFloat(result.rechargeCommissionReverse);

          rechargeTotalSalesAmount = totalRechargeSales;
          rechargeTotalCommissionAmount = totalRechargeCommission;
          rechargeTotalPaidAmount = result?.rechargePaidSum;

          raffleSales = result?.raffleSales || 0;
          raffleCommission = result?.raffleCommission || 0;
          raffleAmountPaid = result?.raffleAmountPaid || 0;
          

          if(parseFloat(lottoTotalSalesAmount) > 0) salesAmount += parseFloat(lottoTotalSalesAmount);
          if(parseFloat(lottoTotalCommissionAmount) > 0) commissionAmount += parseFloat(lottoTotalCommissionAmount);
          if(parseFloat(lottoTotalPaidAmount) > 0) paidAmount += parseFloat(lottoTotalPaidAmount);


          if(parseFloat(rechargeTotalSalesAmount) > 0) salesAmount += parseFloat(rechargeTotalSalesAmount);
          if(parseFloat(rechargeTotalCommissionAmount) > 0) commissionAmount += parseFloat(rechargeTotalCommissionAmount);
          if(parseFloat(rechargeTotalPaidAmount) > 0) paidAmount += parseFloat(rechargeTotalPaidAmount);

          if(parseFloat(raffleSales) > 0) salesAmount += parseFloat(raffleSales);
          if(parseFloat(raffleCommission) > 0) commissionAmount += parseFloat(raffleCommission);
          if(parseFloat(raffleAmountPaid) > 0) paidAmount += parseFloat(raffleAmountPaid);
                    
          total_debit = commissionAmount + paidAmount;
          
          totalDueAmount += Number(salesAmount) 
          totalDueAmount -= Number(total_debit) 
          totalDueAmount -= Number(insensitiveAmount);
          
          
          subTotalDue += Number(totalDueAmount);
          
          old_balance = await fetchUserDue(data?.users_oid);
          subTotalDue += Number(old_balance);
          
          // commissionAmount = Math.floor(commissionAmount * 100) / 100;
          totalDueAmount = Math.floor(totalDueAmount * 100) / 100;
          subTotalDue = Math.floor(subTotalDue * 100) / 100;

        } else {
          status = 'Fail';
          remarks = 'No sales found'
        }

        const params = {
          id : data._id,

          lottoTotalSales : lottoTotalSalesAmount,
          lottoTotalCommission : lottoTotalCommissionAmount,
          lottoPaidAmount : lottoTotalPaidAmount,


          rechargeTotalSales : rechargeTotalSalesAmount,
          rechargeTotalCommission : rechargeTotalCommissionAmount?.toFixed(2) || 0,
          rechargePaidAmount : rechargeTotalPaidAmount,

          //Raffle
          raffleSales       : raffleSales || 0,
          raffleCommission  : raffleCommission || 0,
          raffleAmountPaid  : raffleAmountPaid || 0,

          
          total_sales : salesAmount,
          total_commission : commissionAmount?.toFixed(2) || 0,
          total_paid : paidAmount,
          total_due : totalDueAmount,
          old_pending_balance : old_balance || 0,
          sub_total_due : subTotalDue,
          status : status,
          remarks : remarks
        }
        const invoiceRes = await updateInvoice(params);
        
        
        setListData((prev) =>
          prev.map((item) =>
            item._id === data._id ? { 
              ...item, 

              lottoTotalSales : lottoTotalSalesAmount,
              lottoTotalCommission : lottoTotalCommissionAmount,
              lottoPaidAmount : lottoTotalPaidAmount,


              rechargeTotalSales : rechargeTotalSalesAmount,
              rechargeTotalCommission : rechargeTotalCommissionAmount,
              rechargePaidAmount : rechargeTotalPaidAmount,

              //Raffle
              raffleSales       : raffleSales || 0,
              raffleCommission  : raffleCommission || 0,
              raffleAmountPaid  : raffleAmountPaid || 0,

              total_sales : salesAmount,
              total_commission : commissionAmount?.toFixed(2) || 0,
              total_paid : paidAmount,
              total_due : totalDueAmount,
              old_pending_balance : old_balance || 0,
              sub_total_due : subTotalDue,
              status: params.status, 
              remarks : params.remarks } : item
          )
        );
        setPendingInvoiceCount(pendingInvoiceCount - 1);
      }
    }
  } catch (error) {
    console.log("error", error);
    // setIsLoading(false);
  }
};


const handlePDFDownload = async (invoiceData) => {
  try {  
    const {
      store,users_name,pos_number,users_mobile,sales_person_name,invoice_date,invoice_no,payment_mode,start_date,end_date,start_time,end_time,area,
      lottoTotalSales, lottoTotalCommission, lottoPaidAmount, lottoIncentives,
      rechargeTotalSales, rechargeTotalCommission, rechargePaidAmount, rechargeIncentives,
      raffleSales, raffleCommission, raffleAmountPaid,
      total_sales,total_commission,total_paid,total_due,other_charges,old_pending_balance,sub_total_due,total_incentives,

      } = invoiceData;
      console.log("invoiceData : ", invoiceData);
    const isValidate = true
    if(!isValidate){
      alert('Incomplete invoice data');
    }else{
      
      let previewURL = `/invoice/preview?`
      previewURL    +=  `autoDownload=Y`
      previewURL    +=  `&store_name=${store}`
      previewURL    +=  `&user_name=${users_name}`
      previewURL    +=  `&pos_number=${pos_number}`
      previewURL    +=  `&mobile=${users_mobile}`
      previewURL    +=  `&totalSales=${total_sales}`
      previewURL    +=  `&totalCommission=${total_commission || 0}`
      previewURL    +=  `&paidAmount=${total_paid || 0}`
      previewURL    +=  `&totalDue=${total_due || 0}`
      previewURL    +=  `&other_charges=${other_charges || 0}`
      previewURL    +=  `&old_balance=${old_pending_balance || 0}`
      previewURL    +=  `&subTotalDue=${sub_total_due || 0}`
      previewURL    +=  `&incentives=${total_incentives || 0}`
      previewURL    +=  `&invoice_date=${invoice_date}`
      previewURL    +=  `&invoice_no=${invoice_no}`
      previewURL    +=  `&payment_mode=${payment_mode}`
      previewURL    +=  `&start_date=${start_date}`
      previewURL    +=  `&start_time=${start_time}`
      previewURL    +=  `&end_date=${end_date}`
      previewURL    +=  `&end_time=${end_time}`
      previewURL    +=  `&sales_person_name=${sales_person_name}`
      previewURL    +=  `&area=${area}`

      previewURL    +=  `&lottoTotalSales=${lottoTotalSales || 0}`
      previewURL    +=  `&lottoTotalCommission=${lottoTotalCommission || 0}`
      previewURL    +=  `&lottoPaidAmount=${lottoPaidAmount || 0}`
      previewURL    +=  `&lottoIncentives=${lottoIncentives || 0}`

      previewURL    +=  `&rechargeTotalSales=${rechargeTotalSales || 0}`
      previewURL    +=  `&rechargeTotalCommission=${rechargeTotalCommission || 0}`
      previewURL    +=  `&rechargePaidAmount=${rechargePaidAmount || 0}`
      previewURL    +=  `&rechargeIncentives=${rechargeIncentives || 0}`;

      previewURL    +=  `&raffleSales=${raffleSales || 0}`
      previewURL    +=  `&raffleCommission=${raffleCommission || 0}`
      previewURL    +=  `&rechargePaidAmount=${raffleAmountPaid || 0}`
      previewURL    +=  `&rechargeIncentives=${0}`

      
      window.open(previewURL, '_blank');
    }
  } catch (error) { 
    console.log('error', error)
  }
}

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Invoice Request List"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
           {(ALLLISTDATA?.length > 0 && pendingInvoiceCount > 0) && (
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <h4>Successfully processed {pendingInvoiceCount} out of the {ALLLISTDATA.length} invoices.</h4>  
                  <blink >Preparing {pendingInvoice[pendingInvoiceCount - 1]?.store} invoice... </blink>
                </div>                  
              </div>
            </Box>                      
           )} 
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl No.</th>
                              <th>Customer's Details</th>
                              <th>Period</th>
                              <th>Amount</th>
                              <th>Due Date</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td className="admin_user_list_date"> 
                                      <span>Store : {items?.store}</span><br/>
                                      <span>Name : {items?.users_name}</span><br/> 
                                      <span>Mobile : {items?.users_mobile}</span>
                                    </td>
                                    {/* <td className="admin_user_list_date">
                                      From : {moment(`${items?.start_date}`).subtract(4, 'hours').format("DD-MM-YYYY, hh:mm A")} 
                                      <br/>
                                      To : {moment(`${items?.end_date}`).subtract(4, 'hours').format("DD-MM-YYYY, hh:mm A")} 
                                    </td> */}
                                    <td className="admin_user_list_date">
                                      From : 
                                      {`
                                        ${moment(items?.start_date).format("DD-MM-YYYY")} 
                                        ${moment(`2025-03-03 ${items?.start_time}`).format("hh:mm A")}
                                      `} 
                                      <br/>
                                      To : 
                                      {`
                                        ${moment(`${items?.end_date}`).format("DD-MM-YYYY")} 
                                        ${moment(`2025-03-03 ${items?.end_time}`).format("hh:mm A")}
                                      `} 
                                    </td>
                                    <td className="admin_user_list_date">{items?.total_due?items.total_due.toFixed(2):'-'}</td>
                                    {items?.due_date?(
                                      <td className="admin_user_list_date">
                                        <h6 dangerouslySetInnerHTML={{ __html: getRelativeTime(items?.due_date) }}></h6>
                                        {moment(`${items?.due_date}`).format("DD-MM-YYYY")}
                                      </td>

                                    ):(
                                      <td className="admin_user_list_date">-</td>
                                    )}
                                      
                                    <td className="admin_user_list_date">{items?.status}</td>
                                    <td>
                                      <Dropdown
                                        overlay={
                                          <>
                                            <Menu>
                                              {items?.status === 'Fail'?(
                                                <Menu.Item>{items?.remarks}</Menu.Item>  
                                              ):(<>
                                                <Menu.Item
                                                  key={`02`}
                                                  onClick={() => {
                                                    handlePDFDownload(items);
                                                  }}
                                                >
                                                <FontAwesomeIcon icon={faDownload} /> <span className="show_span">PDF</span>
                                                </Menu.Item>

                                                <Menu.Item
                                                  key={`01`}
                                                  onClick={() => {
                                                    handleRemove(items._id);
                                                  }}
                                                >
                                                   <FontAwesomeIcon icon={faTrash} /> <span className="show_span">Remove</span>
                                                </Menu.Item>
                                              </>)}
                                            </Menu>
                                          </>
                                        }
                                        placement="bottomLeft"
                                        arrow
                                      >
                                       <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={7} /> : <tr> 
                                <td colspan="7" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
    </>
  );
}
